import React from 'react';

function ScoreCard({ label, score, description, accent = false }) {
  const level = score >= 80
    ? 'RIDICAT'
    : score >= 65
      ? 'MODERAT'
      : 'ATIPIC';

  return (
    <article className={`score-card${accent ? ' score-card--accent' : ''}`}>
      <div className="score-card__heading">
        <span>{label}</span>
        <strong>{score}%</strong>
      </div>
      <div
        className="meter"
        role="progressbar"
        aria-label={`${label}: ${score}%`}
        aria-valuenow={score}
        aria-valuemin="0"
        aria-valuemax="100"
      >
        <span style={{ width: `${score}%` }} />
      </div>
      <div className="score-card__footer">
        <b>{level}</b>
        <p>{description}</p>
      </div>
    </article>
  );
}

export default ScoreCard;